import { IconButton } from '@chakra-ui/react';

export const OriginalsSliderButton = (props) => {
  return (
    <IconButton
      height="100%"
      position="absolute"
      borderRadius="none"
      variant="link"
      zIndex="2"
      w={{ base: '40px', lg: '106px' }}
      sx={{
        '.slider &': {
          bg: { base: 'rgba(0, 0, 0, .25)', lg: 'rgba(0, 0, 0, .90)' },
        },
        '.slider:hover &': {
          bg: { base: 'rgba(0, 0, 0, .5)', lg: 'black' },
        },
      }}
      {...props}
    />
  );
};
